<p class="terms">
    By using this site you acknowledge our
    <a target="_blank" [href]="terms">Privacy Policy</a>
</p>
<button (click)="accept()" class="accept">Accept</button>
